import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree/dist/core/type/type';

import { TagSelectionType } from '@/enums/filters';
import { BaseModel } from '@/stores/shared';

export const CountryModel = types.compose(
  BaseModel,
  types.model({
    name: types.maybe(types.string),
    code: types.maybe(types.string),
  }),
);

export type CountryModelType = Instance<typeof CountryModel> & {};

export const CityModel = types.compose(
  BaseModel,
  types.model({
    name: types.maybe(types.string),
  }),
);

export type CityModelType = Instance<typeof CityModel> & {};

const TagGroupExtraConfigModel = types.model({
  formStep: types.maybe(types.string),
  weight: types.maybe(types.number),
  selectAllEnabled: types.maybe(types.boolean),
});

export type TagGroupExtraConfigModelType = Instance<
  typeof TagGroupExtraConfigModel
> & {};

export const TagGroupModel = types.compose(
  BaseModel,
  types.model({
    name: types.string,
    machineName: types.string,
    color: types.string,
    order: types.number,
    isVisible: types.boolean,
    isRequired: types.boolean,
    isArchived: types.maybe(types.boolean),
    selectionType: types.enumeration<TagSelectionType>(
      Object.values(TagSelectionType),
    ),
    extra: TagGroupExtraConfigModel,
  }),
);

export type TagGroupModelType = Instance<typeof TagGroupModel> & {};

export const TagModel = types.compose(
  BaseModel,
  types.model({
    name: types.string,
    order: types.maybe(types.number),
    group: TagGroupModel,
  }),
);

export type TagModelType = Instance<typeof TagModel> & {};

export const UniversityModel = types.compose(
  BaseModel,
  types.model({
    shortName: types.maybe(types.string),
    name: types.maybe(types.string),
    country: types.maybeNull(CountryModel),
  }),
);

export type UniversityModelType = Instance<typeof UniversityModel> & {};

// Is there any way to generify fields inside MST model? There is an option to use `union()`, but that's not
// what is needed in this case. Seems that generics are not available here due to built-in validations, so strict
// types are expected.
const BaseChoiceFieldModel = types.model({
  name: types.string,
  label: types.string,
});

export const IntChoiceFieldModel = types.compose(
  BaseChoiceFieldModel,
  types.model({
    value: types.number,
  }),
);

export type IntChoiceFieldModelType = Instance<typeof IntChoiceFieldModel> & {};

export const StringChoiceFieldModel = types.compose(
  BaseChoiceFieldModel,
  types.model({
    value: types.string,
  }),
);

export type StringChoiceFieldModelType = Instance<
  typeof StringChoiceFieldModel
> & {};
